import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type DentalStepParams, existingDentalInsuranceSchema } from './types'

export const hasExistingDentalInsurance = (params: DentalStepParams) =>
  ({
    schema: existingDentalInsuranceSchema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_has_existing_dental_insurance.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('has_existing_dental_insurance'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('has_existing_dental_insurance'),
      valueToStepName: {
        true: 'ineligible_status',
        false: 'earns_above_threshold',
      },
    },
    subFlow: SubFlow.Dental,
  }) as const satisfies AnyStepConfiguration
